import React from 'react';
import './custom.css'
const DownloadApp = () => {
    return (
        <>
            <div className='d-none d-md-block'>
                <div id='download' style={{ background: '#FFFFFF', padding: '150px 0' }} className='mx-5 d-flex '>
                    <section className='d-md-flex'>
                        <div className='down_div col-md-5 me-5'>
                            <h1 data-aos="flip-up" className='down_header'>Download APP</h1>
                            <span data-aos="fade-up" data-aos-duration="2000" className='down_span'>A carbon neutral planet </span>
                            <div className='down_para'>
                                <p data-aos="fade-up" data-aos-duration="2000">Mobile mining engine has been developed and rolled ​into a user-friendly app for members at the Club. ​Result is a power efficient mobile only DApp that can ​be used by anyone without heavy investment in ASICs, ​GPUS, compute power.</p>
                            </div>
                            <div data-aos="fade-up"
                                data-aos-duration="2000" className=''>
                                <img src="/img/appstore.png" style={{ borderRadius: '10px', cursor: "pointer" }} className="my-4 me-0 me-md-4" alt="" /> <p className='d-md-none p-0 m-0'></p>
                                <img src="/img/playstore.png" style={{ borderRadius: '10px', cursor: "pointer" }} alt="" />
                            </div>
                        </div>
                        <div className=' ms-5 ps-5'>
                            <div className='d-flex '>
                                <div>
                                    <img className='mt-3 backgg' src="/img/rot1.png" alt="" />
                                </div>
                                <div>
                                    <div className=' backg bg-danger' alt="">
                                        <h4 className='text-light px-2 mt-5'>Let’s reduce the carbon footprint together...</h4>
                                        <div className='mx-1' style={{ marginTop: '150px' }}>
                                            <img style={{ cursor: 'pointer' }} className='w-100' src="img/downI2.png" alt="" />
                                            <img style={{ cursor: 'pointer' }} className='mt-2 w-100' src="img/downI1.png" alt="" />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </section >
                </div >
            </div>
            <div className='d-flex justify-content-center align-items-center'>
                <div className='d-block d-md-none'>
                    <div id='download' style={{ background: "#FFFFFF", padding: "50px 0" }} className='d-flex justify-content-center align-items-center alnDown'>
                        <section className=' mx-md-5 px-md-5 py-5'>
                            <div className='row mx-3 mx-md-5'>
                                <div className='col-md-5 mt-5 d-flex justify-content-center align-items-center' style={{ textAlign: 'justify' }}>
                                    <div>
                                        <h1 data-aos="flip-up" className='text-center' style={{ fontFamily: "Poppins", fontWeight: '500', fontSize: '42px', color: 'black' }}>Download APP</h1>
                                        <p className='text-center' style={{ fontFamily: "Poppins", fontWeight: '400', fontSize: '20px', color: '#3399FF' }}>A carbon neutral planet </p>
                                        <div className='mt-2 fs-6 text-center' style={{ fontFamily: "Poppins", fontWeight: '400', fontSize: '20px', color: '#111111' }}>
                                            <p data-aos="fade-up" data-aos-duration="2000" className='minig_text'>Mobile mining engine has been developed and rolled ​into a user-friendly app for members at the Club. ​Result is a power efficient mobile only DApp that can ​be used by anyone without heavy investment in ASICs, ​GPUS, compute power.</p>
                                        </div>
                                        <div className='d-flex justify-content-center'>
                                            <div data-aos="fade-up"
                                                data-aos-duration="3000" className=''>
                                                <img src="/img/appstore.png" style={{ borderRadius: '10px', cursor: "pointer" }} className="my-4 me-0 me-md-4" alt="" /> <p className='d-md-none p-0 m-0'></p>
                                                <img src="/img/playstore.png" style={{ borderRadius: '10px', cursor: "pointer" }} alt="" />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className='col-md-2'></div>
                                <div className='col-md-5 mt-5'>
                                    <div className='d-flex '>
                                        <div>
                                            <img className='mt-3 backgg' src="/img/rot1.png" alt="" />
                                        </div>
                                        <div>
                                            <div className=' backg bg-danger' alt="">
                                                <h4 className='text-light px-2 mt-5 '>Let’s reduce the carbon footprint together...</h4>
                                                <div className='mx-1' style={{ marginTop: '150px' }}>
                                                    <img style={{ cursor: 'pointer' }} className='w-100' src="img/downI2.png" alt="" />
                                                    <img style={{ cursor: 'pointer' }} className='mt-2 w-100' src="img/downI1.png" alt="" />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </section >
                    </div >
                </div>
            </div>
        </>
    );
};

export default DownloadApp;